import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import {
  saveSavedBuild,
  removeSavedBuild,
  getAllSavedBuilds,
  getSavedBuildCount,
} from '../../resources/localStorage/localStorage.service';
import { setSavedBuildCount } from '../../store/actions';

const withSaveBuild = (Component) => {
  const SaveBuildComponent = (props) => {
    const { appResources, config, dispatch } = props;
    const { brand, country } = appResources;

    const currentBuildSavedKey = get(
      getAllSavedBuilds(brand, country).filter(
        (build) => config.ss === build.ss
      )[0],
      'key'
    );

    const save = () => {
      saveSavedBuild(appResources, config);
      dispatch(setSavedBuildCount(getSavedBuildCount(brand, country)));
    };

    const getAll = () => {
      return getAllSavedBuilds(brand, country);
    };

    const remove = (key) => {
      removeSavedBuild(appResources, key);
      dispatch(setSavedBuildCount(getSavedBuildCount(brand, country)));
    };

    return (
      <Component
        {...props}
        saveBuild={save}
        getAllSavedBuilds={getAll}
        removeBuild={(key) => remove(key)}
        currentBuildSavedKey={currentBuildSavedKey}
      />
    );
  };

  const mapStateToProps = (state) => {
    const { config, appResources } = state;

    return {
      appResources,
      config,
    };
  };

  const displayName = Component.displayName || Component.name || 'Component';
  SaveBuildComponent.displayName = `${displayName}withSaveBuild`;
  return connect(mapStateToProps)(SaveBuildComponent);
};

export default withSaveBuild;
